import { useId } from 'react'
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg'

type AppIconArrowTopRightBoldProps = {
  size?: number
}

export function AppIconArrowTopRightBold({ size = 20 }: AppIconArrowTopRightBoldProps) {
  const id = useId()

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fill={`url(#${id})`}
        d="M20.0595 14.1895C20.0595 14.8798 19.4998 15.4395 18.8095 15.4395C18.1191 15.4394 17.5595 14.8798 17.5595 14.1895V8.20703L6.07314 19.6934C5.58504 20.1815 4.79373 20.1813 4.30556 19.6934C3.81742 19.2052 3.81741 18.4139 4.30556 17.9258L15.7919 6.43945H9.80947C9.11913 6.43943 8.55947 5.8798 8.55947 5.18945C8.55947 4.49911 9.11913 3.93947 9.80947 3.93945H18.8095C19.4998 3.93945 20.0595 4.4991 20.0595 5.18945V14.1895Z"
      />
      <Defs>
        <LinearGradient id={id} x1="3.93945" y1="-11.3566" x2="19.4468" y2="28.1919" gradientUnits="userSpaceOnUse">
          <Stop offset="0.16" stopColor="#7BB6FD" />
          <Stop offset="0.973693" stopColor="#0C75F7" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
